import { Help as HelpIcon } from "@mui/icons-material";
import { Stack, Tooltip, TooltipProps, Typography } from "@mui/material";
import React from "react";

interface IProps {
    placement?: TooltipProps["placement"];
    tooltip: React.ReactNode;
    label?: string;
    size?: number;
}

export const InfoTooltip: React.FC<IProps> = ({ placement, tooltip, label, size }) => {
    function renderTooltip() {
        return (
            <Tooltip placement={placement} title={tooltip}>
                <HelpIcon
                    color="disabled"
                    fontSize="small"
                    sx={{ ...(size != null && { width: size, height: size }) }}
                />
            </Tooltip>
        );
    }

    if (label == null) {
        return renderTooltip();
    }

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="inherit">{label}</Typography>
            {renderTooltip()}
        </Stack>
    );
};
